import { Box, Stack } from '@mui/material';
import type { BlueprintSection, DefinitionDataSection } from '../../../types';
import { SegmentationEditor } from '../segmentation/SegmentationEditor';
import { SectionColumnsLayout } from './SectionColumnsLayout';
import { SortingEditor } from '../sorting/SortingEditor';

interface SectionEditorProps {
  blueprintSection: BlueprintSection;
  definitionSection: DefinitionDataSection;
}

export function SectionEditor({ blueprintSection, definitionSection }: SectionEditorProps) {
  return (
    <Stack gap={3}>
      <SectionColumnsLayout
        blueprintSection={blueprintSection}
        definitionSection={definitionSection}
      />

      <Box maxWidth="md">
        <SortingEditor blueprintSection={blueprintSection} sectionId={blueprintSection.id} />
      </Box>

      <Box maxWidth="md">
        <SegmentationEditor blueprintSection={blueprintSection} sectionId={blueprintSection.id} />
      </Box>
    </Stack>
  );
}
